module.exports = ".password-reset-container {\n  min-width: 480px; }\n\n.password-reset-header {\n  padding-top: 8px; }\n\n.password-reset-save-button {\n  min-width: 97px; }\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/password-reset/password-reset.component.scss
// module id = ./client/app/password-reset/password-reset.component.scss
// module chunks = main